export type CardStatus = "VALID" | "INVALID";

export type CardProgram = {
	kind: string;
	name: string;
	title: string | null;
};

export type CardRate = {
	positionId: string;
	position: string;
	percent: number;
};

export type CardCheck = {
	status: CardStatus;
	programs: CardProgram[];
	rates: CardRate[];
	bonusBalance: number;
};

export type CardReward = {
	id: string;
	reward: string;
	pointsCost: number;
	affordable: boolean;
};

export type Redemption = {
	redemptionId: string;
	reward: string;
	pointsCost: number;
	bonusBalance: number;
	redeemedAt: string;
};

export const EMPTY_CARD: CardCheck = {
	status: "INVALID",
	programs: [],
	rates: [],
	bonusBalance: 0,
};
